import type { AxiosApiResponsePromise } from "~/api/apiResponseTypes.ts";
import axiosApi from "~/api/axiosApi.ts";
import { getAllGendersEndpoint } from "~/modules/humanResources/api/gender/genderApiEndpoints.ts";
import type { Gender } from "~/modules/humanResources/api/gender/genderTypes.ts";

export const getAllGenders = (): AxiosApiResponsePromise<Gender[]> => axiosApi.get(getAllGendersEndpoint);
